import { useTranslation } from 'next-i18next'

import { usePageTitle } from '~/utils/tags'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import Metatags from '~/components/Metadata/Metatags'
import DonatePage from '~/donation/pages/Donate.page'
import ReduxPersistor from '~/redux/utils/ReduxPersistor'
import { GetProps } from '~/utils/pageWrapper/types'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import DonationLayout from '~/shared/layouts/DonationLayout'

const MathMagicDonatePage = (): React.ReactElement => {
  const { t } = useTranslation('donation')
  const pageTitle = usePageTitle(t('donatePage.title'))

  return (
    <>
      <Metatags metaDescription={t('metaDescription')} title={pageTitle} />
      <ReduxPersistor>
        <DonatePage />
      </ReduxPersistor>
    </>
  )
}

MathMagicDonatePage.getLayout = DonationLayout

export const getProps: GetProps = () => () => {
  return {
    props: {
      namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'donation'],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)

export default MathMagicDonatePage
